<template>
  <!-- <div>
    <h1>vuex 测试</h1>
    Clicked: {{ getCount }} times
    <button @click="increment">+</button>
    <button @click="decrement">-</button>
  </div> -->
  <div>
			
      		<!-- <el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false"> -->
            <br>
              <br>
                <br>
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >          
			<el-form :model="storyForm" :label-position="labelPosition" :rules="storyFormRules" ref="storyForm">
				<el-form-item >
      <template slot-scope="scope"  >
  				 <img v-if="QRcodeUrl!=''"  @click="see(QRcodeUrl)"  :src="QRcodeUrl" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
		  				 <img v-if="storyForm.ImageUrlStr!=''"  @click="see(storyForm.ImageUrlStr)"  :src="storyForm.ImageUrlStr" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >

			</template>	
			<!-- <template slot-scope="scope"  >
			</template>				 -->
      	</el-form-item>	        	
				<el-form-item label="门店名称" prop="Name" >
					<el-input v-model="storyForm.Name" auto-complete="off"></el-input>
				</el-form-item>			
        <el-form-item label="门店负责人" prop="LinkMan" >
					<el-input  v-model="storyForm.LinkMan" auto-complete="off"></el-input>
				</el-form-item>
        	<el-form-item label="负责人电话" prop="Mobile">
					<el-input  v-model="storyForm.Mobile" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="门店电话">
					<el-input  v-model="storyForm.Tel" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="地址">
					<el-input  v-model="storyForm.Address" auto-complete="off"></el-input>
				</el-form-item>
				<!-- <el-form-item label="地址">
           <div class="block">
           <span class="demonstration">hover 触发子菜单</span>
            <el-cascader
                v-model="value"
               :options="options"
               :props="{ expandTrigger: 'hover' }"
               @change="handleChange"></el-cascader>
            </div>
				</el-form-item> -->


			</el-form>
        </el-col >
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
        <el-button type="warning" @click.native="Download" >下载分享二维码</el-button>
					<el-button size="small" type="primary" @click="imageShow()">上传门店印章</el-button>                   

			</div>
		<!-- </el-dialog> -->
    		<el-dialog title="查看大图" v-model="seeImageVisible">
					<div style="width:100%;margin:0 auto; text-align:center;"><img   :src="imgUrl" style=" background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; "></div>
			
		</el-dialog>

		         <el-dialog id="tt" title="上传" v-model="uploadimageVisible" >
             <el-upload
              class="upload-demo"
              drag action=""
              :http-request="upload"
              multiple customClass=".el-upload-dragger">
             <i class="el-icon-upload"></i>
             <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
             <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
		</el-dialog>	
</div>

</template>


<script>
	import {mapGetters} from 'vuex';
   import {shopUploadImage,getShopInfor,editshopt,GetGenerate,DownloadImage} from  '../../api/api';
  export default {
    data(){
      return{
				shopId:'',
				uploadimageVisible:false,
				seeImageVisible:false,
				imgUrl:'',        
        QRcodeUrl:'',
				value: [],

      				
        // addFormVisible: true,//新增界面是否显示
				addLoading: false,
			
				storyFormRules: {
					Name: [
						{ required: true, message: '请输入门店名称', trigger: 'blur' }
          ],
          LinkMan:[
            
          {required:true,message:'门店负责人必填',trigger: 'blur'}
            
          ],
          Mobile:[
            
          {required:true,message:'负责人电话必填',trigger: 'blur'}
            
          ]
          
				},
        //新增界面数据
				labelPosition: 'top',
				shopinfo:[],
				storyForm: {
					Id:'',
					Name: '',			
          LinkMan:'',
					Tel:'',
					Mobile: '',
			   	Address:''
				
					
				}
      }
    },
 

   
   methods: {

 		imageShow()
			{
			// console.log("111"+upload);
			this.shopId="";
			  this.uploadimageVisible=true;
			  
			},    			
 		upload(param)
			{
			    var fileObj=param.file;
				var fd=new FormData();
				fd.append("file",fileObj);
			  	shopUploadImage(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}		              
			  }).catch(error=>{
                 alert('网络错误');
                });
			},           					 
			Download(){


		   let para={
		   }
		   DownloadImage(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/x-jpg"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = "分享二维码.jpg"; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })		   
			},
 			Generate(){
				let para={
						shopId:JSON.parse(this.getuserstate()).TenancyId,				
				}
              GetGenerate(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                  //  this.$message({
									// message: Msg,
									// type: 'success'
									// });	
									this.QRcodeUrl=res.data.Data;								
								}else
								{
                //   this.$message({
								// 	message: Msg,
								// 	type: 'error'
								// });
								}				  		
			    }).catch(error=>{
				});				
			},    
      			see(Image){
                     this.imgUrl=Image;
                  this.seeImageVisible=true;
              },   
      handleChange(value) {
        console.log(value);
      },
    	 
		 ...mapGetters(['getuserstate']),
    // ...mapActions([
    //   'increment', // 映射 this.increment() 为 this.$store.dispatch('increment')
    //   'decrement'
    // ]),
      //...mapActions({
      //  add: 'increment' // 映射 this.add() 为 this.$store.dispatch('increment')
      //})
        //显示新增界面
	   getStoryInfo:function(){
					let TenancyId=JSON.parse(this.getuserstate()).TenancyId;
					// console.log(localhoststoryid.storyid);
					let para ={
						TenancyId:TenancyId
					}
           getShopInfor(para).then((res)=>{
						//  console.log(res);
						 let list=res.data;
						 if(list.lenght<1)
						 {

						 }
						 else
						 {
						 this.storyForm=res.data[0];

						 }

					 })
		 },
     editSubmit: function () {
				this.$refs.storyForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.storyForm);
							// para.birthday = (!para.birthday || para.birthday == '') ? '' : util.formatDate.format(new Date(para.birthday), 'yyyy-MM-dd');
							editshopt(para).then((res) => {
								this.addLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['storyForm'].resetFields();
								this.getStoryInfo();
							}) .catch(error=>{
             alert('系统错误');
            });
						});
					}
				});
			}
			 },
			 mounted() {
      this.getStoryInfo();
      this.Generate();
		}


	}

</script>


// WEBPACK FOOTER //
// ShopInfo.vue?fefcbf7a